export const cancellable = <T>(
  promise: Promise<T>,
): [Promise<T>, () => void] => {
  let reject;

  const newPromise: Promise<T> = new Promise((resolveFn, rejectFn) => {
    reject = rejectFn;
    promise.then(resolveFn, rejectFn);
  });

  const cancel = () => {
    reject('Promise is cancelled');
  };

  return [newPromise, cancel];
};
